const totalMessageHeight = (total, element) => {
  return total + element.scrollHeight;
};

export const calculateScrollTop = (
  conversationPanelHeight,
  parentHeight,
  relevantMessages
) => {
  // add up scrollHeight of a `relevantMessages`
  let combinedMessageScrollHeight = [...relevantMessages].reduce(
    totalMessageHeight,
    0
  );
  return (
    conversationPanelHeight - combinedMessageScrollHeight - parentHeight / 2
  );
};

export const isReaderAboveBottom = (
  { scrollHeight, scrollTop, clientHeight },
  threshold = 80
) => scrollHeight - scrollTop - clientHeight > threshold;

export const shouldPreserveReaderPosition = ({
  isWorkspaceV2,
  hasUserScrolled,
  messageId,
}) => isWorkspaceV2 && hasUserScrolled && !messageId;
